<template>
  <section class="wrapper for_bg">
        <div class="container">
          <div class="text_wrapper">
            <h1 class="about">
              <span class="about_wr"
                >Эй! Доброго вам дня! Если вы тут то ищите специалиста для того
                что бы сделать сайт. Вуаля вы тут. Я тот к то вам нужен. Меня
                зовут Улугбек. Я <span class="bold">Front-end Developer</span>. Хорошо владеющий
                современными техлогиями, такими как: <span class="html_color">HTML</span>, <span class="css_color">CSS</span>, <span class="js_color">JavaScript</span>.
                Также не будет лишним упомянуть фреймворки и библиотеки c которыми
                я умею работать <span class="jq_color">JQeury</span>, <span class="v_color">VueJS</span>, <span class="r_color">ReactJS</span>, <span class="b_color">Bootstrap</span>, <span class="bl_color">Bulma</span>.</span
              >
            </h1>
          </div>
        </div>
      </section>
</template>

<script>
export default {
    name: 'about',
}
</script>

<style>
.for_bg {
  background-image: url("./assets/photo_1.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.text_wrapper {
  max-width: 570px;
  padding: 0 20px;
  box-sizing: border-box;
}
.text_wrapper h1 {
  line-height: 40px;
  font-weight: 500;
}
.text_wrapper h1 span.about_wr {
  background-color: #fff;
  padding: 1px 6px;
}
.bold {
  font-weight: bold;
}

span.html_color {
  color: #fc4011;
}
span.css_color {
  color: #00b89c;
}
span.js_color {
  color: #ffca00;
}
span.jq_color {
  color: #0769ad;
}
span.v_color {
  color: #42b983;
}
span.r_color {
  color: #61dafb;
}
span.b_color {
  color: #563d7c;
}
span.bl_color {
  color: #00d1b2;
}
@media (max-width: 400px){
    .text_wrapper h1{
      line-height: 30px;
      font-size: 18px;
    }
}
</style>


// WEBPACK FOOTER //
// src/header.vue